<script setup lang="ts">
import LeDoubleArrow from "@dsk/icons/LeDoubleArrow.vue";
import LeLongArrow from "@dsk/icons/LeLongArrow.vue";
import LeStack from "@dsk/icons/LeStack.vue";
import { type Component, computed } from "vue";

import type { SearchDirection, SearchLanguage } from "@/types";

const props = defineProps<{
  sourceLanguage: SearchLanguage;
  direction: SearchDirection;
  targetLanguage?: SearchLanguage;
}>();

const directionIconComponent = computed<Component>(() => (props.direction === "one-way" ? LeLongArrow : LeDoubleArrow));
</script>

<template>
  <span class="le-language-pair">
    <span>{{ props.sourceLanguage.code.toUpperCase() }}</span>
    <Component :is="directionIconComponent" :width="12" :height="12" role="presentation" />
    <span v-if="props.targetLanguage">{{ props.targetLanguage.code.toUpperCase() }}</span>
    <span v-else class="le-language-pair__icon">
      <LeStack :width="16" :height="16" />
    </span>
  </span>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-language-pair {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: @colors[@neutrals][300];

  &__icon {
    line-height: 0;
  }
}
</style>
